document.addEventListener('alpine:init', () => {
    window.Alpine.data('accordionItem', (config) => ({
        id: config.id ?? null,
        open: config.open ?? false,
        item: null,
        hiddenContainer: null,
        init() {
            this.item = this.$refs['item' + this.id];
            this.hiddenContainer = this.$refs['container' + this.id];

            if(this.open) {
                this.openItem();
            }
        },
        toggleAnswer() {
            this.open = !this.open;
            if (this.open) {
                this.openItem();
            } else {
                this.item.style.maxHeight = 0;
            }
        },
        setItemHeight() {
            if(this.open) {
                this.item.style.maxHeight = getComputedStyle(this.hiddenContainer).height;
            }
        },
        openItem() {
            this.item.style.maxHeight = getComputedStyle(this.hiddenContainer).height;
        },
    }));
});